import './SectionsContent.scss';

import cn from 'classnames';
import React from 'react';
import { NavLink } from 'react-router-dom/cjs/react-router-dom.min';

import Picture from '@/common/components/atoms/Picture/Picture';
import { ROUTE_NODES_CATEGORY } from '@/common/constants';
import getImageBySize from '@/common/helpers/getImageBySize';
import { PRODUCTS_TYPES_FORMATS } from '@/ebat/constants';

import {
  SectionsContentDefaultProps,
  SectionsContentPropTypes,
} from './SectionsContents.proptypes';

const SectionsContent = ({ className, allDepths, categories }) => {
  /**
   * Return image alt or product name
   * @returns {string}
   */
  const getImageAlt = (section) => section.image?.alt;

  /**
   * Return image src or empty string
   * @returns {string}
   */
  const getImageSrc = (section) =>
    section.image?.url
      ? getImageBySize(section.image.url, PRODUCTS_TYPES_FORMATS.MOSAIC)
      : '';

  return (
    <div className={cn('sections', className)}>
      <span className="sections__title">Nos catégories</span>
      <div className="sections__categories">
        {categories.map((section) => (
          <NavLink
            className={cn('section__card', {
              'section__card--no-icon':
                allDepths.length > 1 || !section?.image?.url,
            })}
            key={section.slug}
            to={`${ROUTE_NODES_CATEGORY}/${allDepths.join('/')}/${
              section.slug
            }`}
          >
            {allDepths.length === 1 && section?.image?.url && (
              <Picture
                alt={getImageAlt(section)}
                className="card__image"
                src={getImageSrc(section)}
              />
            )}

            <span>{section.name}</span>
          </NavLink>
        ))}
      </div>
    </div>
  );
};

SectionsContent.defaultProps = {
  ...SectionsContentDefaultProps,
};

SectionsContent.propTypes = {
  ...SectionsContentPropTypes,
};

export default SectionsContent;
